import React, { useContext, useState } from 'react';
import { LoadingContext } from '@context/LoadingProvider';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { requestMagicLink } from '@general/api/memberAPI';
import { Form, Formik } from 'formik';
import TextInput from '@atoms/TextInput';
import { ButtonPrimaryLarge } from '@styled';
import MembershipCta from '../MembershipCta';
import useStytchQueryString from '../../../../hooks/useStytchQueryString';

const Request = () => {
    const { setIsLoading } = useContext(LoadingContext);
    const { search } = useLocation();
    const history = useHistory();
    const { path: matchPath } = useRouteMatch();
    const stytchQueryString = useStytchQueryString();

    const [username, setUsername] = useState('');

    const onSubmit = async () => {
        setIsLoading(true);

        try {
            await requestMagicLink(
                username,
                `${window.location.origin}${window.location.pathname}/authenticate${stytchQueryString}`
            );
            history.push(`${matchPath}/confirmation`);
        } catch (e) {
            console.log(e);
        }

        setIsLoading(false);
    };

    return (
        <>
            <h2 className="display5 text-center bold mb-4">Log in without a password</h2>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                We’ll send a one-time link to the email address associated with your account. This link will expire in 2
                hours.
            </p>

            <Formik initialValues={{ username }} onSubmit={onSubmit}>
                {() => (
                    <Form className="mb-4">
                        <TextInput
                            label="Email Address or Member ID#"
                            placeholder="Email Address or Member ID#"
                            name="username"
                            value={username}
                            onChange={e => {
                                setUsername(e.target.value);
                            }}
                            required
                        />
                        <ButtonPrimaryLarge className="w-100 mt-1">Log In Without a Password</ButtonPrimaryLarge>
                    </Form>
                )}
            </Formik>

            <div className="text-center">
                <p className="display8 mb-2">Prefer to sign in using your password?</p>
                <Link to={`/login${search}`} className="d-block display8 accent mb-2">
                    Log In With a Password
                </Link>
            </div>

            <MembershipCta />
        </>
    );
};

Request.propTypes = {};

export default Request;
